// ─── DESIGN TOKENS ──────────────────────────────────────────────────────────
export const C = {
  black:      "#0A0A0A",
  charcoal:   "#1A1A1A",
  gray:       "#5A5A5A",
  muted:      "#8A8A8A",
  border:     "#E8E8E8",
  surface:    "#F7F7F5",
  white:      "#FFFFFF",
  accent:     "#D4292A",
  accentDark: "#AA1F20",
  accentLight:"#FDEAEA",
};

// ─── IMAGES (Unsplash – production/India context) ────────────────────────────
export const IMGS = {
  hero:      "https://images.unsplash.com/photo-1585345966744-6e9a31c4c494?w=1600&q=85&fit=crop",
  camera:    "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=1400&q=85&fit=crop",
  studio:    "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=1400&q=85&fit=crop",
  director:  "https://images.unsplash.com/photo-1540655037529-dec987208707?w=1400&q=85&fit=crop",
  adShoot:   "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=1400&q=85&fit=crop",
  social:    "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=1400&q=85&fit=crop",
  fashion:   "https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=1400&q=85&fit=crop",
  food:      "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=1400&q=85&fit=crop",
  team:      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1400&q=85&fit=crop",
  editing:   "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=1400&q=85&fit=crop",
  aboutHero: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1600&q=85&fit=crop",
  contact:   "https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=1600&q=85&fit=crop",
};

// ─── NAVIGATION ──────────────────────────────────────────────────────────────
export const NAV_LINKS = [
  { label: "Home",     page: "home"     },
  { label: "About",    page: "about"    },
  { label: "Services", page: "services" },
  { label: "Work",     page: "work"     },
  { label: "Contact",  page: "contact"  },
];

// ─── SERVICES ────────────────────────────────────────────────────────────────
export const SERVICES = [
  {
    id: "video-production",
    no: "01",
    title: "Video Production",
    tagline: "Cinematic stories that move people",
    description:
      "From concept to final cut, we produce high-quality video content built for impact. Brand films, product videos, documentary reels — handled with industry-standard equipment, expert direction, and meticulous post-production. Every single frame earns its place.",
    features: ["Brand Films", "Product Videos", "Documentary Reels", "Corporate Films", "Colour Grading", "Sound Design"],
    image: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=1400&q=85&fit=crop",
  },
  {
    id: "advertisement",
    no: "02",
    title: "Advertisement Commercials",
    tagline: "Ads that sell. Stories that stick.",
    description:
      "We produce high-end commercials — cinematic, story-driven, and conversion-focused. Full concept development, professional scripting, and stylised production from our Chennai studio. We make ads that don't just inform but compel immediate action.",
    features: ["TV Commercials", "Digital Ads", "Product Launches", "Brand Campaigns", "Script Writing", "Storyboarding"],
    image: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=1400&q=85&fit=crop",
  },
  {
    id: "social-media",
    no: "03",
    title: "Social Media Management",
    tagline: "Consistent. Creative. Converting.",
    description:
      "We manage your entire social presence end-to-end — strategy, content creation, scheduling, community management, and analytics. From Instagram Reels to YouTube Shorts, we build a digital voice that grows with purpose and backed by data.",
    features: ["Content Strategy", "Reel Production", "Community Management", "Analytics Reports", "Paid Ads", "Influencer Tie-ups"],
    image: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=1400&q=85&fit=crop",
  },
];

// ─── PORTFOLIO ───────────────────────────────────────────────────────────────
export const PORTFOLIO = [
  { id: 1, title: "Ethnic Wear Campaign",     cat: "Fashion Film",     client: "Saree Brand, Chennai",     year: "2024", img: "https://images.unsplash.com/photo-1583391733956-6c78276477e2?w=800&q=80&fit=crop" },
  { id: 2, title: "Cloud Kitchen Reels",      cat: "Ad Commercial",    client: "Food Startup, Bangalore",  year: "2024", img: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=800&q=80&fit=crop" },
  { id: 3, title: "Founders Story Film",      cat: "Brand Film",       client: "Tech Startup, Chennai",    year: "2024", img: "https://images.unsplash.com/photo-1540655037529-dec987208707?w=800&q=80&fit=crop" },
  { id: 4, title: "30-Second Launch Spot",    cat: "TV Commercial",    client: "FMCG Brand, Mumbai",       year: "2025", img: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=800&q=80&fit=crop" },
  { id: 5, title: "Social Presence Overhaul", cat: "Social Media",     client: "Restaurant Group",         year: "2025", img: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=800&q=80&fit=crop" },
  { id: 6, title: "Product Brand Film",       cat: "Video Production", client: "D2C Brand, Hyderabad",     year: "2025", img: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=800&q=80&fit=crop" },
];

// ─── STATS ───────────────────────────────────────────────────────────────────
export const STATS = [
  { value: "200+", label: "Projects Delivered" },
  { value: "50+",  label: "Brand Partners"     },
  { value: "3+",   label: "Years of Excellence"},
  { value: "2M+",  label: "Views Generated"    },
];

// ─── PROCESS ─────────────────────────────────────────────────────────────────
export const PROCESS = [
  { no: "01", title: "Discovery",   desc: "Deep-dive into your brand, audience, and goals to build the creative foundation."     },
  { no: "02", title: "Strategy",    desc: "Scripts, storyboards, and visual direction crafted with precision and intent."         },
  { no: "03", title: "Production",  desc: "Full-scale shoot with professional crew, gear, and on-set creative direction."         },
  { no: "04", title: "Delivery",    desc: "Editing, grading, sound design, and final export in all formats you need."             },
];

// ─── TESTIMONIALS ─────────────────────────────────────────────────────────────
export const TESTIMONIALS = [
  {
    quote: "Tharagai transformed our brand completely. The brand film they produced doubled our social engagement within two weeks of launch.",
    name: "Priya Krishnan",
    company: "D2C Fashion Brand, Chennai",
  },
  {
    quote: "The team understood our product and our customers better than agencies we'd worked with for years. Professional, fast, and deeply creative.",
    name: "Arjun Mehta",
    company: "Food Startup, Bangalore",
  },
  {
    quote: "From concept to delivery in 7 days — and the quality was cinematic. The best production house we've worked with in South India.",
    name: "Kavitha Nair",
    company: "Restaurant Group, Chennai",
  },
];

// ─── WORK CATEGORIES ─────────────────────────────────────────────────────────
export const WORK_CATS = [
  "All", "Fashion Film", "Ad Commercial", "Brand Film",
  "TV Commercial", "Social Media", "Video Production",
];

// ─── FAQS ─────────────────────────────────────────────────────────────────────
export const FAQS = [
  {
    q: "How long does a typical project take?",
    a: "Brand films and ad commercials usually take 7–14 days from brief to delivery. Social media content batches are typically ready in 3–5 days. We also accommodate urgent timelines.",
  },
  {
    q: "Do you work with small businesses?",
    a: "Absolutely. Every brand deserves world-class storytelling regardless of size. We offer flexible packages for all budgets — from first-time brand shoots to large-scale campaigns.",
  },
  {
    q: "Where are you based and do you travel?",
    a: "We're based in Chennai and regularly serve clients across Tamil Nadu, Bangalore, Hyderabad, and Mumbai. We're happy to travel for the right project.",
  },
  {
    q: "Do you offer monthly retainers?",
    a: "Yes — our Social Media Management service is available on monthly retainers. We also offer ongoing video production retainers for brands with regular content needs.",
  },
  {
    q: "Can I see your full portfolio?",
    a: "Of course. Reach out via the form and we'll share our full production reel and relevant case studies matched to your industry and project type.",
  },
  {
    q: "What should I share to get started?",
    a: "Just tell us about your brand, what you're trying to achieve, your timeline, and budget range. We'll come back with a tailored proposal within 24 hours.",
  },
];
